<!-- Passengers -->
<div class="weight-medium pb-1">
  <em class="mdi mdi-account has-text-grey is-size-6"></em>

  {{ 'itinerary-info.passengers-info.title' | translate }}
</div>
<div class="columns is-size-6 mb-1pt">
  <div class="column">
    <!-- Info -->

    <div class="is-size-6" *ngFor="let passenger of passengers">
      • {{ passenger.firstName }} {{ passenger.lastName }}
    </div>
  </div>
</div>
